"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var glamor_1 = require("glamor");

var glamor_tachyons_1 = require("glamor-tachyons");

var surface_1 = require("./surface");

var tabs_1 = require("./tabs");

var VisorComponent =
/*#__PURE__*/
function (_preact_1$Component) {
  _inherits(VisorComponent, _preact_1$Component);

  _createClass(VisorComponent, null, [{
    key: "render",
    value: function render(parent, replaceNode, props) {
      return preact_1.render(preact_1.h(VisorComponent, Object.assign({}, props)), parent, replaceNode);
    }
  }]);

  function VisorComponent(props) {
    var _this;

    _classCallCheck(this, VisorComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisorComponent).call(this, props));
    _this.surfaces = new Map();
    var startOpen = props.startOpen == null ? true : props.startOpen;
    _this.state = {
      isOpen: startOpen,
      isFullscreen: false,
      activeTab: null,
      tabs: new Set()
    };
    _this.keyHandler = _this.keyHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VisorComponent, [{
    key: "close",
    value: function close() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "open",
    value: function open() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "toggleFullScreen",
    value: function toggleFullScreen() {
      this.setState({
        isFullscreen: !this.state.isFullscreen
      });
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.state.isOpen;
    }
  }, {
    key: "isFullscreen",
    value: function isFullscreen() {
      return this.state.isFullscreen;
    }
  }, {
    key: "getSurface",
    value: function getSurface(label, tab) {
      var surfaceId = this.surfaceId(label, tab);
      var surface;

      if (this.surfaces.has(surfaceId)) {
        surface = this.surfaces.get(surfaceId);
      } else {
        throw Error("Surface not found with id: ".concat(surfaceId));
      }

      return {
        container: surface.container,
        label: surface.label,
        drawArea: surface.drawArea
      };
    }
  }, {
    key: "bindKeys",
    value: function bindKeys() {
      document.addEventListener('keydown', this.keyHandler, false);
    }
  }, {
    key: "unbindKeys",
    value: function unbindKeys() {
      document.removeEventListener('keydown', this.keyHandler);
    }
  }, {
    key: "surfaceId",
    value: function surfaceId(label, tab) {
      return label + tab;
    }
  }, {
    key: "setTabs",
    value: function setTabs(surfaceList) {
      var nextTabs = surfaceList.map(function (s) {
        return s.tab;
      });
      var tabs = this.state.tabs;
      var newActiveTab;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = nextTabs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tab = _step.value;

          if (!tabs.has(tab)) {
            tabs.add(tab);
            newActiveTab = tab;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (newActiveTab != null) {
        this.setState({
          tabs: tabs,
          activeTab: newActiveTab
        });
      }
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      return this.state.tabs;
    }
  }, {
    key: "registerSurface",
    value: function registerSurface(name, tab, surface) {
      var surfaceId = this.surfaceId(name, tab);
      this.surfaces.set(surfaceId, surface);
    }
  }, {
    key: "keyHandler",
    value: function keyHandler(event) {
      var BACKTICK_KEY = 192;

      if (event.keyCode === BACKTICK_KEY) {
        if (event.shiftKey) {
          this.toggleFullScreen();
        } else {
          this.toggle();
        }
      }
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tab) {
      this.setState({
        activeTab: tab
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.bindKeys();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setTabs(this.props.surfaceList);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setTabs(nextProps.surfaceList);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          isFullscreen = _this$state.isFullscreen,
          activeTab = _this$state.activeTab;
      var surfaceList = this.props.surfaceList;
      var tabNames = Array.from(this.getTabs().values());
      var SMALL_WIDTH = '550px';
      var LARGE_WIDTH = '90vw';
      var width = isFullscreen ? LARGE_WIDTH : SMALL_WIDTH;
      var defaultStyles = glamor_1.css({
        width: width,
        height: '100%',
        backgroundColor: '#fafafa',
        boxSizing: 'border-box',
        padding: '10px',
        position: 'fixed',
        top: '0px',
        transition: "right 0.5s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.5s cubic-bezier(0.645, 0.045, 0.355, 1)",
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)',
        overflow: 'auto',
        fontFamily: 'sans-serif',
        fontSize: '14px',
        zIndex: 1000
      });
      var openStyle = glamor_1.css({
        right: '0'
      });
      var closedStyle = glamor_1.css({
        right: "calc(-".concat(width, " - 10px)")
      });
      var position = isOpen ? openStyle : closedStyle;
      var surfacesContainerStyle = glamor_1.css({});
      return preact_1.h("div", {
        className: "".concat(defaultStyles, " ").concat(position, " visor"),
        "data-isopen": isOpen,
        "data-isfullscreen": isFullscreen
      }, preact_1.h(VisorControls, {
        fullScreenHandler: this.toggleFullScreen.bind(this),
        closeHandler: this.close.bind(this),
        isFullScreen: isFullscreen
      }), preact_1.h(tabs_1.Tabs, {
        tabNames: tabNames,
        activeTab: activeTab,
        handleClick: this.setActiveTab.bind(this)
      }), preact_1.h("div", {
        className: "".concat(surfacesContainerStyle, " visor-surfaces")
      }, surfaceList.map(function (surfaceInfo) {
        return preact_1.h(surface_1.SurfaceComponent, {
          key: surfaceInfo.name + surfaceInfo.tab,
          name: surfaceInfo.name,
          tab: surfaceInfo.tab,
          styles: surfaceInfo.styles,
          registerSurface: _this2.registerSurface.bind(_this2),
          visible: activeTab === surfaceInfo.tab
        });
      })));
    }
  }]);

  return VisorComponent;
}(preact_1.Component);

exports.VisorComponent = VisorComponent;

function VisorControls(props) {
  var isFullScreen = props.isFullScreen,
      fullScreenHandler = props.fullScreenHandler,
      closeHandler = props.closeHandler;
  var toolBarStyle = glamor_1.css({
    display: 'flex',
    backgroundColor: 'white',
    border: '1px solid white',
    padding: '6px',
    paddingTop: '10px',
    marginBottom: '10px',
    borderRadius: '6px',
    marginTop: '-16px'
  });
  var controlsButtonClass = glamor_1.css(Object.assign({}, glamor_tachyons_1.tachyons('f6 link br2 ph3 pv2 near-black')));
  var floatRight = glamor_1.css({
    marginLeft: 'auto'
  });
  return preact_1.h("div", {
    className: "".concat(toolBarStyle, " visor-controls")
  }, preact_1.h("button", {
    className: "".concat(controlsButtonClass),
    onClick: fullScreenHandler
  }, isFullScreen ? 'Minimize' : 'Maximise'), preact_1.h("button", {
    className: "".concat(controlsButtonClass, " ").concat(floatRight),
    onClick: closeHandler
  }, "Hide"));
}